import { createSelector } from 'reselect';
import last from 'lodash/last';
import type { State } from '../../types.tsx';
import { getOrderedAssignees } from '../cards/index.tsx';
import { getAppliedParentFilters, getFilters } from '../filters/index.tsx';

export const getMostRecentAssigneeFilter = createSelector(
	getFilters,
	getOrderedAssignees,
	(filters, allAssignees) => {
		const assignees = filters.ASSIGNEE;

		if (assignees && assignees.length > 0) {
			const lastSelectedKey = assignees[assignees.length - 1];
			const lastSelected = allAssignees.find((assignee) => assignee.id === lastSelectedKey);
			if (lastSelected) {
				return lastSelected;
			}
		}

		return null;
	},
);

export const getAppliedLabelFilters = (state: State) => {
	const labels = state.ui.filters.LABEL;

	if (labels && labels.length > 0) {
		return labels;
	}

	return null;
};

export const getLastAppliedParentFilters = createSelector(getAppliedParentFilters, (parentIds) => {
	if (parentIds && parentIds.length > 0) {
		return Number(last(parentIds));
	}

	return null;
});
